module.exports = __webpack_public_path__ + "static/media/0029_IMG_LE_PLAFOND_CHROMATIC_CH2_1039.58570131.webp";